import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "inputRef", "onBlur", "onFocus", "value"];
import React, { useRef } from 'react';
import { CustomPropTypes, defineProps, useEventListener } from '@beef/react';
import { SearchInput } from '@beef/ui-kit';
import PropTypes from 'prop-types';
var useEnsuredRef = function useEnsuredRef(externalRef) {
  var localFallbackRef = useRef();
  return externalRef || localFallbackRef;
};
export var NSearchInput = function NSearchInput(_ref) {
  var className = _ref.className,
    inputRef = _ref.inputRef,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  inputRef = useEnsuredRef(inputRef);
  useEventListener('blur', function (event) {
    return onBlur(value, event);
  }, inputRef);
  useEventListener('focus', function (event) {
    return onFocus(value, event);
  }, inputRef);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-NSearchInput"
  }, /*#__PURE__*/React.createElement(SearchInput, _extends({
    extraAttributes: {
      style: {
        overflow: 'hidden',
        paddingRight: '25px',
        textOverflow: 'ellipsis'
      }
    },
    inputRef: inputRef,
    value: value
  }, props)));
};
NSearchInput.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  helpMessage: PropTypes.string,
  inputRef: CustomPropTypes.ref,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string
} : {};
export var NSuggestInput = defineProps(undefined, {
  leftAside: null
})(NSearchInput);